import React, { useEffect, useState } from "react";
import AppLayout from "../../layout/index";
import moment from "moment";
import { useLocation } from "react-router-dom";
import getApiData from "../../services/getApiData";

const itemsPerPage = 10;
const maxIndexButtons = 5;

const searchArticles = (articles, searchTerm) => {
  const searchTermRegex = new RegExp(`\\b${searchTerm}`, "i");
  return articles.filter((article) => searchTermRegex.test(article.name));
};

const filterArticles = (articles, studyModes, filterType) => {
  console.log(studyModes);
  const filtered = articles.filter((article) => {
    return article.properties.tags.some((item) => studyModes.includes(item));
  });
  return filtered;
};

const sortArticles = (articles, sort) => {
  const sortArticles = articles.sort((a, b) => {
    const dateA = a.properties.date ? new Date(a.properties.date) : null;
    const dateB = b.properties.date ? new Date(b.properties.date) : null;
    if (sort === undefined || sort === "descending") {
      // Handle null dates by placing them at the end
      if (dateA === null && dateB === null) {
        return 0;
      } else if (dateA > dateB) {
        return -1;
      } else if (dateA < dateB) {
        return 1;
      } else {
        return dateA - dateB;
      }
    } else if (sort === "Oldest") {
      if (dateA === null && dateB === null) {
        return 0;
      } else if (dateA > dateB) {
        return 1;
      } else if (dateA < dateB) {
        return -1;
      } else {
        return dateA - dateB;
      }
    }
  });

  return sortArticles;
};

const filterArticlesByStartDate = (articles, startBy) => {
  return articles.filter((article) => {
    const targetDate = moment(article.properties.date);
    const currentDate = moment();
    const weekDifference = targetDate.diff(currentDate, "weeks");
    const monthDifference = targetDate.diff(currentDate, "months");

    switch (startBy) {
      case "Updated in the last week":
        return weekDifference > -1 && articles;
      case "Updated in the last month":
        return monthDifference > -1 && articles;
      case "Updated in the last year":
        return monthDifference > -12 && articles;
      default:
      // Handle other cases or set a default value
    }
  });
};

const getTopics = (articles) => {
  // get unique categories
  let vb = [];
  articles.map((type) => {
    vb.push(type.properties.tags);
  });

  const __flattenReducer = (result, value) => {
    if (value instanceof Array) {
      return value.reduce(__flattenReducer, result);
    } else {
      result.push(value);
      return result;
    }
  };

  const flatten = function (arr) {
    if (arr instanceof Array) {
      return Array.prototype.reduce.apply(arr, [__flattenReducer, []]);
    } else {
      throw new TypeError("Expected an array");
    }
  };

  const yu = flatten(vb);

  function mergeUsingSpread(...inputArrays) {
    let uniqueValues = new Set();

    // Using loop to go thofugh each array
    inputArrays.forEach((arr) => {
      // Here, adding the element of current
      // array into the Set of uniqueValues
      arr.forEach((ele) => {
        uniqueValues.add(ele);
      });
    });

    // Converting the set to array
    return Array.from(uniqueValues);
  }

  // Multiple Input arrays
  let outputArray = mergeUsingSpread(yu);

  // create new array only showing unique topics
  const topics = outputArray.map((el1) => ({
    name: el1,
    checked: false,
  }));

  return topics;
};

const Page = () => {
  const [isOpenMobileFilters, setIsOpenMobileFilters] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [articles, setArticles] = useState([]);
  const [getAllArticles, setGetAllArticles] = useState([]);
  const [articlesCount, setArticlesCount] = useState(0);
  const [getCat, setCat] = useState([]);
  const [accordionData, setAccordionData] = useState([]);

  useEffect(() => {
    // get unique topics
    const topicList = getTopics(getAllArticles);
    setCat(topicList);
  }, [getAllArticles]);

  // set category filter checkboxes from topiclist
  useEffect(() => {
    const filters = [
      {
        title: "Category",
        type: "categoryFilter",
        checkbox: getCat,
      },
    ];
    setAccordionData(filters);
  }, [getCat]);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const initialPage = parseInt(searchParams.get("page"), 10) || 1;
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [loading, setLoading] = useState(true);
  const [filterIsModified, setFilterIsModified] = useState(false);

  const paramNames = ["startDate", "sort", "categoryFilter", "searchTerm"];

  const [filter, setFilter] = useState(() => {
    const initialState = {};
    paramNames.forEach((param) => {
      if (param === "categoryFilter") {
        const paramValue = searchParams.get(param);
        initialState[param] = paramValue ? paramValue.split(",") : [];
      } else {
        initialState[param] = searchParams.get(param) || "";
      }
    });
    return initialState;
  });

  const initialFilter = {
    startDate: "",
    sort: "",
    categoryFilter: [],
    searchTerm: "",
  };

  const getData = async () => {
    setLoading(true);
    const response = await getApiData();
    setLoading(false);
    const returnedNewsArticles = response?.items ?? [];
    // console.log(returnedNewsArticles);
    setPageRequest(returnedNewsArticles);
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array ensures that this effect runs once

  useEffect(() => {
    // Update the URL when the page or search term changes
    const newSearchParams = new URLSearchParams();
    newSearchParams.set("page", currentPage);

    const paramsToSet = ["searchTerm", "categoryFilter", "startDate", "sort"];
    paramsToSet.forEach((param) => {
      newSearchParams.set(param, filter[param]);
    });

    // Use replaceState to prevent adding a new entry to the history stack
    window.history.replaceState({}, "", `#/docs?${newSearchParams.toString()}`);
  }, [currentPage, filter]);

  useEffect(() => {
    const hasFilterSetted =
      JSON.stringify(filter) !== JSON.stringify(initialFilter);
    setFilterIsModified(hasFilterSetted);

    const loadedAccordionData = [];

    const updateCheckedProperty = (checkbox, value) => {
      checkbox.checked = value;
    };

    accordionData.map((category) => {
      const arrayToCheck =
        category.type === "categoryFilter" ? filter.categoryFilter : [];
      category.checkbox.forEach((checkbox) => {
        updateCheckedProperty(checkbox, arrayToCheck.includes(checkbox.name));
      });

      loadedAccordionData.push(category);
    });

    setAccordionData(loadedAccordionData);

    let articlesFiltered = getAllArticles;

    sortArticles(articlesFiltered);

    if (filter.searchTerm) {
      setCurrentPage(1);
      articlesFiltered = searchArticles(articlesFiltered, filter.searchTerm);
    }

    if (filter.categoryFilter.length) {
      setCurrentPage(1);
      articlesFiltered = filterArticles(
        articlesFiltered,
        filter.categoryFilter,
        "categoryFilterType"
      );
    }

    if (filter.startDate) {
      setCurrentPage(1);
      articlesFiltered = filterArticlesByStartDate(
        articlesFiltered,
        filter.startDate
      );
    }

    if (filter.sort) {
      setCurrentPage(1);
      articlesFiltered = sortArticles(articlesFiltered, filter.sort);
    }

    setArticles(articlesFiltered);
    setArticlesCount(articlesFiltered.length);
  }, [filter, getAllArticles]);

  const newTabWindowLink = (article) => {
    const link = article.properties.document[0]?.url;

    return link;
  };

  const selectionHandle = (event, selection) => {
    const value = event.target.value;
    setFilter((prevFilter) => ({
      ...prevFilter,
      [selection]: value,
    }));
  };

  const setPageRequest = (articlesData) => {
    if (Array.isArray(articlesData)) {
      setArticles(articlesData);
      setGetAllArticles(articlesData);
      setArticlesCount(articlesData.length);
      setLoading(false);
    } else {
      console.error("Invalid data format");
      // If the data format is invalid, use an empty array
      setArticles([]);
      setGetAllArticles([]);
      setArticlesCount(0);
    }
  };

  const toggleMobileFilters = (e) => {
    setIsOpenMobileFilters(!isOpenMobileFilters);
    e.preventDefault();
  };

  const newsroomCountAmount = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, articles.length);

    if (articlesCount > 1) {
      return (
        <p className="article-count">
          {`Showing ${startIndex + 1} to ${endIndex} of `}
          <strong>{`${articles.length}`}</strong> articles
        </p>
      );
    } else if (articlesCount === 1) {
    } else if (loading) {
      return <p className="load-block pulse"></p>;
    } else if (articlesCount === 0) {
      return (
        <p className="article-count">
          <strong>{articlesCount}</strong> results found
        </p>
      );
    }
  };

  const docsDate = (article) => {
    const date = moment(article.properties.date);
    const formattedDate = date.format("MMMM Do YYYY");
    return article.properties.date === null ? "" : formattedDate;
  };

  const countSortBy = () => {
    return (
      <div className="article-count-sort-by-wrapper">
        {newsroomCountAmount()}
        <label className="ds-fe-label ds-h4" htmlFor="sort">
          Sort by
        </label>
        <div className="ds-fe-dropdown">
          <select
            className="ds-fe-dropdown__select"
            id="sort"
            name="sort"
            value={filter.sort} // Set the value of the dropdown to the state variable
            onChange={(e) => selectionHandle(e, "sort")} // Set the event handler for dropdown changes
          >
            <option value="descending">Most recent</option>
            <option value="Oldest">Oldest</option>
          </select>
        </div>
      </div>
    );
  };

  const searchByStartDate = () => {
    return (
      <div className="ds-search-sort ds-fe-group">
        <label className="ds-fe-label" htmlFor="startDate">
          <h3>Article date</h3>
        </label>
        <div className="ds-fe-dropdown">
          <select
            className="ds-fe-dropdown__select"
            id="startDate"
            name="startDate"
            value={filter.startDate} // Set the value of the dropdown to the state variable
            onChange={(e) => selectionHandle(e, "startDate")} // Set the event handler for dropdown changes
          >
            <option value="">Anytime</option>
            <option value="Updated in the last week">
              Updated in the last week
            </option>
            <option value="Updated in the last month">
              Updated in the last month
            </option>
            <option value="Updated in the last year">
              Updated in the last year
            </option>
          </select>
        </div>
      </div>
    );
  };

  const countSortByMobile = () => {
    return (
      <div className="ds-search-sort ds-fe-group">
        <label className="ds-fe-label ds-h3" htmlFor="sort2">
          Sort by
        </label>
        <div className="ds-fe-dropdown">
          <div className="ds-fe-dropdown">
            <select
              className="ds-fe-dropdown__select"
              id="sort2"
              name="sort2"
              value={filter.sort} // Set the value of the dropdown to the state variable
              onChange={(e) => selectionHandle(e, "sort")} // Set the event handler for dropdown changes
            >
              <option value="">Most recent</option>
              <option value="Oldest">Oldest</option>
            </select>
          </div>
        </div>
      </div>
    );
  };

  const handleNextPage = (e) => {
    e.preventDefault();
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const handlePrevPage = (e) => {
    e.preventDefault();
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleJumpToPage = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const generatePageIndexPagination = () => {
    const Li = [];
    const totalPagesForArticles = Math.ceil(articles.length / itemsPerPage);
    const halfMaxButtons = Math.floor(maxIndexButtons / 2);

    let startPage = Math.max(currentPage - halfMaxButtons, 1);
    let endPage = Math.min(
      startPage + maxIndexButtons - 1,
      totalPagesForArticles
    );

    if (endPage - startPage < maxIndexButtons - 1) {
      startPage = Math.max(endPage - maxIndexButtons + 1, 1);
    }

    if (startPage > 1) {
      Li.push(
        <li key={1} className="ds-pagination__item">
          {1 === currentPage ? (
            1
          ) : (
            <a
              href="/#"
              onClick={(e) => handleJumpToPage(e, 1)}
              className="ds-link"
            >
              1
            </a>
          )}
        </li>
      );

      if (startPage > 2) {
        Li.push(
          <li key="prevDots" className="ds-pagination__item">
            ...
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      Li.push(
        <li key={i} className={"ds-pagination__item"}>
          {i === currentPage ? (
            i
          ) : (
            <a
              href="/#"
              onClick={(e) => handleJumpToPage(e, i)}
              className="ds-link"
            >
              {i}
            </a>
          )}
        </li>
      );
    }

    if (endPage < totalPagesForArticles) {
      if (endPage < totalPagesForArticles - 1) {
        Li.push(
          <li key="nextDots" className="ds-pagination__item">
            ...
          </li>
        );
      }

      Li.push(
        <li
          key={totalPagesForArticles}
          className={
            totalPagesForArticles === currentPage
              ? "ds-pagination__item"
              : "ds-pagination__item"
          }
        >
          {totalPagesForArticles === currentPage ? (
            totalPagesForArticles
          ) : (
            <a
              href="/#"
              onClick={(e) => handleJumpToPage(e, totalPagesForArticles)}
              className="ds-link"
            >
              {totalPagesForArticles}
            </a>
          )}
        </li>
      );
    }
    return Li;
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, articles.length);

  const currentNewsroomItems = articles.slice(startIndex, endIndex);

  const totalPages = Math.ceil(articles.length / itemsPerPage);

  const ArticlesFound = (currentNewsroomItems) => {
    const contentLoad = Array.from({ length: 5 }, (_, index) => (
      <div className="load-wrapper" key={index}>
        <div className="loader-title pulse"></div>
        <div className="loader-content pulse"></div>
      </div>
    ));
    return (
      <div className="ds-css-grid-3-col">
        {loading ? (
          <div className="load-wrapper-main">{contentLoad}</div>
        ) : currentNewsroomItems.length > 0 ? (
          currentNewsroomItems.map((article, index) => (
            <a
              key={index}
              href={newTabWindowLink(article)}
              className="ds-content-card ds-p-sm"
              target="_blank" rel="noreferrer"
            >
              <h2 className="ds-m-sm ds-h3">{article.name}</h2>
              <p className="ds-p-sm">
                <strong>{docsDate(article)}</strong>
              </p>
            </a>
          ))
        ) : (
          <div
            className="ds-msg-summary ds-msg-summary--warning"
            style={{ marginTop: "40px" }}
          >
            <div className="ds-msg-summary__header">
              <svg className="ds-msg-summary__icon">
                <use
                  xlinkHref="#ds-general-warning-circle"
                  href="#ds-general-warning-circle"
                ></use>
              </svg>
              <h2 className="ds-msg-summary__title ds-h3">
                There are no matching results
              </h2>
            </div>
            <div className="ds-msg-summary__info">
              <p>Improve your search results by:</p>
              <ul className="ds-unordered-list">
                <li>Removing filters</li>
                <li>Double-checking your spelling</li>
                <li>Using fewer keywords</li>
                <li>Searching for something less specific</li>
              </ul>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="template-search">
      <div className="ds-m-b-lg">
        <h1 id="ds-main-content">Publications</h1>
        <div className="ds-col-1 ds-col-md-2-3 ds-p-r-xl ds-p-r-sm-none">
          <form id="searchBar_form" className="ds-search-bar">
            <input
              id="searchBar_input"
              aria-label="Search"
              type="text"
              value={filter.searchTerm}
              className="ds-search-bar__input ds-fe-input"
              placeholder="Search for news article or subject..."
              onChange={(e) =>
                setFilter((prevFilter) => ({
                  ...prevFilter,
                  searchTerm: e.target.value,
                }))
              }
            />
            <button
              className="ds-search-bar__btn"
              type="submit"
              onClick={(e) => e.preventDefault()}
            >
              <svg>
                <title>Search</title>
                <use
                  xlinkHref="#ds-general-search"
                  href="#ds-general-search"
                ></use>
              </svg>
            </button>
          </form>
        </div>
      </div>
      <div className="ds-grid">
        <div className="main ds-col-1 ds-m-b-xl ds-p-r-lg ds-p-r-sm-none">
          {!isMobile && countSortBy()}
          <div style={{ paddingBottom: "20px" }}>
            {isMobile && newsroomCountAmount()}
          </div>
          {isMobile && countSortByMobile()}
          {isMobile && searchByStartDate()}
          <div
            className="ds-hide-desktop mobile-sticky-btn"
            onClick={toggleMobileFilters}
          >
            <button
              className="ds-btn ds-btn--primary ds-btn--block"
              id="show_filter_btn"
              aria-controls="search_filter"
              aria-expanded="false"
            >
              Filter your results
            </button>
          </div>
          {ArticlesFound(currentNewsroomItems)}
          <div className="ds-pagination ds-m-t-xl">
            {currentPage > 1 && (
              <button
                onClick={handlePrevPage}
                disabled={currentPage === 1}
                className="ds-pagination__prev ds-link ds-btn--link ds-link--with-chevron"
              >
                
                <svg className="ds-link__chevron ds-link__chevron--left">
                  <use
                    xlinkHref="#ds-general-chevron-right"
                    href="#ds-general-chevron-right"
                  ></use>
                </svg>{" "}
                Previous page
                </button>
            )}
            <ol className="ds-pagination__nav">
              {generatePageIndexPagination()}
            </ol>
            {currentNewsroomItems.length === 10 && !loading && (
              <a
                onClick={handleNextPage}
                href="/#"
                target="_self"
                className="ds-pagination__next ds-link ds-link--with-chevron"
              >
                Next page
                <svg className="ds-link__chevron ds-link__chevron--right">
                  <use
                    href="#ds-general-chevron-right"
                  ></use>
                </svg>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const News = () => {
  const breadCrumb = [
    {
      name: "Publications",
    },
  ];

  const WrappedComponent = AppLayout(Page, { breadCrumb });
  return <WrappedComponent />;
};

export default News;
